/* Bootstrap entry for the Drop application. */
import DropApp from "./drop-app.js";

new DropApp();
